import { CommitmentTime } from '../../commitment/CommitmentTime'
import { OverviewSection } from '../../overview/OverviewSection'
import { withCommitment } from '../../wrappers/withCommitment'
import { CommitmentSectionTitle } from './CommitmentSectionTitle'
import { CommitmentStart } from './CommitmentStart'

const CommitmentSectionInternal = () => (
  <OverviewSection>
    <CommitmentSectionTitle />
    <CommitmentStart />
    <CommitmentTime />
  </OverviewSection>
)

export const CommitmentSection = withCommitment(CommitmentSectionInternal)
